import { apiGet, useApiMutation } from "../utils/api";
import { ProjectHeader } from "./project_header";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { usePageModal } from "./page_modal";
import { Action, Draggable, DraggableCanvas, DraggableItem } from "./pages_canvas";
import classNames from "classnames";
import { useEffect, useState } from "react";
import { cloneDeep } from "lodash";

declare global {
  interface Window {
    moving: HTMLElement | null;
  }
}

type Position = {
  top: number;
  left: number;
  width: number;
  height: number;
};

export const Pages = () => {
  const { projectId } = useParams();
  const { post, put } = useApiMutation();
  const [pages, setPages] = useState([]);

  const { data, refetch, isSuccess } = useQuery({
    queryKey: ["data", "x"],
    queryFn: () => apiGet(`/projects/${projectId}/pages`).then((res) => res.data),
    keepPreviousData: true,
  });

  useEffect(() => {
    setPages(data?.pages || []);
  }, [data]);

  const handleUpdates = (actions: { item: any; position: Position }[]) => {
    const newPages = cloneDeep(pages);
    actions.forEach(({ item, position }) => {
      Object.assign(newPages.find((p) => p._path === item._path).position, position);
    });
    setPages(newPages);

    actions.map(({ item, position }) => put(item._path, { position }));
  };

  const PageModal = usePageModal();

  const { project } = data || { project: {} };

  const addPage = () => {
    post(`/projects/${project.id}/pages`, {
      name: "New Page",
      position: { top: 400, left: 20, width: 100, height: 100 },
    }).success(refetch);
  };

  return (
    <>
      <ProjectHeader project={project} refetch={refetch} />

      <DraggableCanvas
        handleUpdates={handleUpdates}
        boxes={{
          model: "page",
          items: pages,
          render: (page: DraggableItem & any, zoom: number, isSelected: boolean) => (
            <div
              className={classNames("page", {
                "zoom-sm": zoom < 1,
                "zoom-md": zoom === 1,
                "zoom-lg": zoom > 1,
                selected: isSelected,
              })}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                PageModal.set(page._path);
              }}
            >
              <div>{page.name}</div>
              {zoom > 1 && page.has_image && (
                <img
                  src={page.images[0].path}
                  alt={page.name}
                  className="flex-grow-1 object-fit-contain mt-2"
                />
              )}
              {zoom === 1 && page.has_image && <i className="bi bi-image mt-2" />}
            </div>
          ),
        }}
      >
        <div className="text-end">
          <button className="btn btn-outline-primary btn-sm bg-white" onClick={addPage}>
            Add Page
          </button>
        </div>
      </DraggableCanvas>

      <PageModal refetch={refetch} />
    </>
  );
};
